// src/pages/Profile.js
import api from '../services/api'; // Import default
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  getProfile, 
  updateProfile, 
  changePassword,
  deleteAccount 
} from '../services/api';
import { useAuth } from '../context/AuthContext';



function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    bio: '',
    avatar_url: ''
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [deletePassword, setDeletePassword] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [contenidoAdulto, setContenidoAdulto] = useState(false);
  const [mostrarVerificacion, setMostrarVerificacion] = useState(false);
  const [fechaNacimiento, setFechaNacimiento] = useState('');
  const [documentoId, setDocumentoId] = useState('');
  const [mensaje, setMensaje] = useState({ type: '', text: '' });
  const [uploading, setUploading] = useState(false);
  const [previewAvatar, setPreviewAvatar] = useState(null);
	
const { user } = useAuth(); // ← Agrega esta línea después de los useState	
	
	// Configuración de escalado
	const resizeConfig = {
	  quality: 0.8,
	  maxWidth: 400,
	  maxHeight: 400,
	  autoRotate: true,
	  debug: true,
	  mimeType: 'image/webp' // Convertir a WebP (mejor compresión)
	};
	
  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {<strong></strong>
    setLoading(true);
    try {
      const response = await getProfile();
	  console.log('📥 Perfil cargado:', response.data);
      setProfile(response.data.profile || {});
      setFormData({
        username: response.data.profile.username || '',
        bio: response.data.profile.bio || '',
        avatar_url: response.data.profile.avatar_url || ''
      });
    } catch (error) {
      console.error('Error cargando perfil:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value
    });
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      const response = await updateProfile(formData);
      setProfile(response.data.profile);
      setEditing(false);
      setMessage({ type: 'success', text: 'Perfil actualizado correctamente' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.error || 'Error al actualizar' });
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setMessage({ type: 'error', text: 'Las contraseÃ±as no coinciden' });
      return;
    }

    if (passwordData.newPassword.length < 6) {
      setMessage({ type: 'error', text: 'La contraseÃ±a debe tener al menos 6 caracteres' });
      return;
    }

    try {
      await changePassword(passwordData.currentPassword, passwordData.newPassword);
      setChangingPassword(false);
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setMessage({ type: 'success', text: 'ContraseÃ±a actualizada correctamente' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.error || 'Error al cambiar contraseÃ±a' });
    }
  };

  const handleDeleteAccount = async (e) => {
    e.preventDefault();
    
    if (!window.confirm('Â¿EstÃ¡s SEGURO? Esta acciÃ³n es IRREVERSIBLE y eliminarÃ¡ TODAS tus historias.')) {
      return;
    }

    try {
      await deleteAccount(deletePassword);
      await logout();
      navigate('/');
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.error || 'Error al eliminar cuenta' });
    }
  };
				  
	const formatDate = (dateString) => {
	  if (!dateString) return 'Fecha no disponible';
	  try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return 'Fecha no disponible';
		return date.toLocaleDateString('es-ES', {
		  year: 'numeric',
		  month: 'long',
		  day: 'numeric'
		});
	  } catch {
		return 'Fecha no disponible';
	  }
	};
		  
	const iniciarVerificacion = () => {
	  setMostrarVerificacion(true);
	};

	const handleVerificarEdad = async (e) => {
	  e.preventDefault();

	  // Calcular edad
	  const hoy = new Date();
	  const nacimiento = new Date(fechaNacimiento);
	  let edad = hoy.getFullYear() - nacimiento.getFullYear();
	  const mes = hoy.getMonth() - nacimiento.getMonth();

	  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
		edad--;
	  }

	  if (edad < 18) {
		alert('Debes ser mayor de 18 aÃ±os para acceder a contenido adulto');
		return;
	  }

	  try {
		// Aqui llamaras a tu endpoint de verificacion
		// await verifyAge(documentoId, fechaNacimiento);

		setProfile(prev => ({ ...prev, es_adulto: true }));
		setMostrarVerificacion(false);
		alert('Edad verificada correctamente');

	  } catch (error) {
		console.error('Error verificando edad:', error);
		alert('Error al verificar edad');
	  }
	};
	  
// Función para redimensionar imagen usando Canvas (nativo del navegador)
const resizeImage = (file) => {
  return new Promise((resolve, reject) => {
    // Crear un FileReader para leer la imagen
    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        // Crear canvas
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // Limitar tamaño máximo a 400px
        const MAX_SIZE = 400;
        
        if (width > height) {
          if (width > MAX_SIZE) {
            height = (height * MAX_SIZE) / width;
            width = MAX_SIZE;
          }
        } else {
          if (height > MAX_SIZE) {
            width = (width * MAX_SIZE) / height;
            height = MAX_SIZE;
          }
        }
        
        canvas.width = Math.round(width);
        canvas.height = Math.round(height);
        
        // Dibujar imagen redimensionada
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        // Convertir a Blob (formato WebP para mejor compresión)
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error('No se pudo crear el blob'));
            return;
          }
          
          // Crear un nuevo File con el blob
          const resizedFile = new File([blob], 'avatar.webp', { 
            type: 'image/webp',
            lastModified: Date.now()
          });
          
          console.log('✅ Imagen redimensionada:', {
            original: (file.size / 1024).toFixed(2) + 'KB',
            nueva: (blob.size / 1024).toFixed(2) + 'KB',
            dimensiones: `${canvas.width}x${canvas.height}`
          });
          
          resolve(resizedFile);
        }, 'image/webp', 0.8); // 80% calidad
      };
      
      img.onerror = () => {
        reject(new Error('Error al cargar la imagen'));
      };
    };
    
    reader.onerror = () => {
      reject(new Error('Error al leer el archivo'));
    };
  });
};

				// Handle file upload - AHORA SIN DEPENDENCIAS EXTERNAS
		const handleFileUpload = async (e) => {
		  const file = e.target.files[0];
		  if (!file) {
			console.log('No file selected');
			return;
		  }

		  setUploading(true);
		  setMensaje({ type: '', text: '' });

		  try {
			// Validar tipo de archivo
			if (!file.type.startsWith('image/')) {
			  throw new Error('Solo se permiten imágenes');
			}

			// Redimensionar la imagen
			const resizedImage = await resizeImage(file);

			// Crear FormData
			const formData = new FormData();
			formData.append('avatar', resizedImage);

			// Subir al servidor
			const response = await api.post('/avatar/upload', formData, {
			  headers: { 'Content-Type': 'multipart/form-data' }
			});

			console.log('✅ Avatar subido:', response.data);

			// Actualizar UI
			setFormData(prev => ({ ...prev, avatar_url: response.data.url }));
			setProfile(prev => ({ ...prev, avatar_url: response.data.url }));
			setMensaje({ type: 'success', text: '✅ Avatar actualizado' });

		  } catch (error) {
			console.error('Error:', error);
			setMensaje({ 
			  type: 'error', 
			  text: error.message || '❌ Error al procesar la imagen' 
			});
		  } finally {
			setUploading(false);
			// Limpiar el input file
			e.target.value = null;
			setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
		  }
		};	  
	  
  if (loading) {
    return <div className="loading-screen">Cargando perfil...</div>;
  }

  return (
    <div className="profile-container">
      <h1>Mi Perfil</h1>

      {message.text && (
        <div className={`profile-message ${message.type}`}>
          {message.text}
        </div>
      )}

      {/* SecciÃ³n de avatar */}
      <div className="profile-avatar-section">
        <div className="avatar-container">
          {profile?.avatar_url ? (
            <img src={`${profile.avatar_url}?t=${Date.now()}`}  alt="avatar" className="profile-avatar" />
          ) : (
            <div className="profile-avatar-placeholder">
              {profile?.username?.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
      </div>

		{/* Avatar preview */}
		<div className="avatar-preview">
		  {uploading ? (
			<div className="avatar-preview-loading">
			  <div className="loading-spinner small"></div>
			  <p>Procesando...</p>
			</div>
		  ) : previewAvatar ? (
			<img src={previewAvatar} alt="Preview" className="avatar-preview-img" />
		  ) : formData.avatar_url ? (
			<img src={`${formData.avatar_url}?t=${Date.now()}`}  alt="Avatar" className="avatar-preview-img" />
		  ) : (
			<div className="avatar-preview-placeholder">
			  <span>{profile?.username?.charAt(0).toUpperCase() || '?'}</span>
			</div>
		  )}
		</div>

      {/* InformaciÃ³n del perfil */}
      <div className="profile-info">
        {!editing ? (
          <>
            <div className="info-row">
              <label>Usuario:</label>
              <span>{profile?.username}</span>
            </div>
            <div className="info-row">
              <label>Email:</label>
              <span>{profile?.email}</span>
              {profile?.email_verified ? (
                <span className="verified-badge">✓ Verificado</span>
              ) : (
                <span className="unverified-badge">✗ No verificado</span>
              )}
            </div>
            <div className="info-row">
              <label>Bio:</label>
              <span>{profile?.bio || 'Sin descripci&oacute;n'}</span>
            </div>
            <div className="info-row">
              <label>Miembro desde:</label>
              <span>{formatDate(profile?.created_at)}</span>
            </div>
            
            <button onClick={() => setEditing(true)} className="btn-edit-profile">
             ✏️ Editar perfil
            </button>
          </>
        ) : (
          <form onSubmit={handleUpdateProfile} className="profile-edit-form">
            <div className="form-group">
              <label>Usuario</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="form-group bio-group">
			  <label>Biografía</label>
			  <textarea
				name="bio"
				value={formData.bio}
				onChange={handleInputChange}
				rows="5"
				placeholder="Cuéntanos sobre ti... tus universos, tus creaciones, tu esencia como Creador."
				className="bio-textarea"
				maxLength="500"
			  />
			  <small className="bio-counter">{formData.bio.length}/500 caracteres</small>
			</div>

            <div className="avatar-upload-section">
			  <label>Avatar</label>
			  <div className="avatar-upload-container">
				<div className="avatar-preview">
				  {formData.avatar_url ? (
					<img src={`${formData.avatar_url}?t=${Date.now()}`} alt="Avatar" className="avatar-preview-img" />
				  ) : (
					<div className="avatar-preview-placeholder">
					  <span>{user?.username?.charAt(0).toUpperCase() || '?'}</span>
					</div>
				  )}
				</div>

				<div className="avatar-input-group">
				  <input
					type="url"
					name="avatar_url"
					value={formData.avatar_url}
					onChange={handleInputChange}
					placeholder="https://ejemplo.com/avatar.jpg"
					className="avatar-input"
				  />
				  <p className="avatar-help">
					⚡ URL de una imagen cuadrada (recomendado: 200x200 píxeles)
				  </p>
				  <div className="avatar-buttons">
					<button type="button" className="btn-upload" onClick={() => document.getElementById('file-input').click()} disabled={uploading}>
					  {uploading ? '📁 Subiendo...' : '📁 Subir archivo'}
					</button>
					<input
					  id="file-input"
					  type="file"
					  accept="image/*"
					  style={{ display: 'none' }}
					  onChange={handleFileUpload}
					/>
				  </div>
				</div>
			  </div>
			</div>

            <div className="profile-edit-buttons">
              <button type="submit" className="btn-save">Guardar cambios</button>
              <button type="button" onClick={() => setEditing(false)} className="btn-cancel">
                Cancelar
              </button>
            </div>
          </form>
        )}
      </div>

      {/* Cambiar contrase&ntilde;a */}
      <div className="profile-section">
        <h2>Seguridad</h2>
        {!changingPassword ? (
          <button onClick={() => setChangingPassword(true)} className="btn-change-password">
            🔒 Cambiar contrase&ntilde;a
          </button>
        ) : (
          <form onSubmit={handleChangePassword} className="password-form">
            <div className="form-group">
              <label>ContraseÃ±a actual</label>
              <input
                type="password"
                name="currentPassword"
                value={passwordData.currentPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label>Nueva contraseÃ±a</label>
              <input
                type="password"
                name="newPassword"
                value={passwordData.newPassword}
                onChange={handlePasswordChange}
                required
                minLength="6"
              />
            </div>

            <div className="form-group">
              <label>Confirmar nueva contraseÃ±a</label>
              <input
                type="password"
                name="confirmPassword"
                value={passwordData.confirmPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>

            <div className="profile-edit-buttons">
              <button type="submit" className="btn-save">Cambiar contrase&ntilde;a</button>
              <button type="button" onClick={() => setChangingPassword(false)} className="btn-cancel">
                Cancelar
              </button>
            </div>
          </form>
        )}
      </div>

			{/* SecciÃ³n de contenido adulto */}
			<div className="profile-section">
			  <h2>🔞 Contenido para adultos</h2>

			  {profile?.es_adulto ? (
				<div className="adult-settings">
				  <label className="checkbox-label">
					<input 
					  type="checkbox" 
					  checked={contenidoAdulto}
					  onChange={(e) => setContenidoAdulto(e.target.checked)}
					/>
					<span>Permitir contenido para adultos en mis historias</span>
				  </label>
				  <p className="warning-text">
					⚠️ Esto puede incluir temas maduros, violencia, o situaciones complejas.
					Solo activa esta opci&oacute;n si eres mayor de edad y est&aacute;s de acuerdo con este tipo de contenido.
				  </p>
				</div>
			  ) : (
				<div className="age-verification">
				  <p>Para acceder a contenido maduro, debes verificar tu edad.</p>

				  {!mostrarVerificacion ? (
					<button 
					  onClick={iniciarVerificacion}
					  className="btn-verify-age"
					>
					  Verificar mi edad
					</button>
				  ) : (
					<form onSubmit={handleVerificarEdad} className="verify-form">
					  <div className="form-group">
						<label>Fecha de nacimiento</label>
						<input
						  type="date"
						  value={fechaNacimiento}
						  onChange={(e) => setFechaNacimiento(e.target.value)}
						  required
						  max={new Date().toISOString().split('T')[0]}
						/>
					  </div>

					  <div className="form-group">
						<label>Documento de identidad (opcional)</label>
						<input
						  type="text"
						  value={documentoId}
						  onChange={(e) => setDocumentoId(e.target.value)}
						  placeholder="N&uacute;mero de documento"
						/>
					  </div>

					  <div className="profile-edit-buttons">
						<button type="submit" className="btn-save">
						  Verificar edad
						</button>
						<button 
						  type="button" 
						  onClick={() => setMostrarVerificacion(false)}
						  className="btn-cancel"
						>
						  Cancelar
						</button>
					  </div>
					</form>
				  )}
				</div>
			  )}
			</div>

      {/* Eliminar cuenta */}
      <div className="profile-section danger">
        <h2>Zona de peligro</h2>
        {!deleting ? (
          <button onClick={() => setDeleting(true)} className="btn-delete-account">
            🗑️ Eliminar cuenta permanentemente
          </button>
        ) : (
          <form onSubmit={handleDeleteAccount} className="delete-form">
            <p className="warning-text">
              ⚠️ Esta acci&oacute;n NO SE PUEDE DESHACER. Se eliminar&aacute;n TODAS tus historias y datos.
            </p>
            <div className="form-group">
              <label>Confirma tu contrase&ntilde;a para eliminar la cuenta</label>
              <input
                type="password"
                value={deletePassword}
                onChange={(e) => setDeletePassword(e.target.value)}
                required
              />
            </div>
            <div className="profile-edit-buttons">
              <button type="submit" className="btn-delete-confirm">
                🗑️ Si, eliminar mi cuenta
              </button>
              <button type="button" onClick={() => setDeleting(false)} className="btn-cancel">
                Cancelar
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default Profile;